import * as React from 'react';

import EmbeddedPromoTemplatePageModule from 'bundles/page-config-common/components/shared/EmbeddedPromoTemplatePageModule';
import { useHeaderLevel } from 'bundles/page-config-common/contexts/HeaderLevelContext';
import { useEmbeddedPromoTemplatePage } from 'bundles/page-config-common/contexts/enterprise/EmbeddedPromoTemplatePageContext';

const EmbeddedPromoTemplatePageModuleRenderer = () => {
  const { page } = useEmbeddedPromoTemplatePage();
  const { currentLevel } = useHeaderLevel();

  if (!page) {
    return null;
  }

  const blocksWithHeaderHierarchy = page.blocks.map((block) => {
    if (block.__typename === 'PromoTemplateCollections') {
      return {
        ...block,
        headlineComponent: currentLevel,
      };
    }
    return block;
  });

  return (
    <EmbeddedPromoTemplatePageModule
      page={{
        ...page,
        blocks: blocksWithHeaderHierarchy,
      }}
    />
  );
};

export default EmbeddedPromoTemplatePageModuleRenderer;
